import React from "react";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import type { FileUploadItemProps } from "@components/FileUpload/FileUpload.types";
import { t } from "i18next";

const FileUploadItem: React.FC<FileUploadItemProps> = ({
  isDragActive,
  testId,
  getRootProps,
  getInputProps,
  open,
  uploadDescription,
  disabled,
  hasError,
}) => {
  const borderStyleClass = hasError ? "border-solid" : "border-dashed";
  const stateClasses = hasError
    ? "border-[#E1172F] bg-white"
    : isDragActive
      ? "border-primaryBlue bg-blue-50"
      : "border-[#E6EDF2] bg-white";
  const containerClasses = `
        border-2 ${borderStyleClass} rounded-md w-full 
        flex items-center justify-center gap-4 pt-4 pb-4 transition-colors
  ${disabled ? "cursor-default opacity-70" : "cursor-pointer"}
  ${stateClasses}
      `;
  const actionTextColor = "text-[#0A46B7]";
  const inputProps = getInputProps();

  return (
    <div
      {...getRootProps({
        className: containerClasses,
      })}
      onClick={(e) => {
        e.preventDefault();
        if (!disabled) open();
      }}
      data-testid={testId}
    >
      <input {...inputProps} />
      <div className="flex flex-col items-center">
        <div className={`flex gap-4 py-4 ${actionTextColor}`}>
          <FileUploadOutlinedIcon />
          <span
            data-testid={`${testId}-drag-or-select-text`}
            className={`font-medium text-center align-middle text-lg ${disabled ? "opacity-70" : ""}`}
          >
            {t("upload.dragOrUpload")}
          </span>
        </div>
        <span
          data-testid={`${testId}-upload-description`}
          className="text-[#646A77] text-xs text-center"
        >
          {uploadDescription ?? t("upload.dragOrDropDescription")}
        </span>
      </div>
    </div>
  );
};

export default FileUploadItem;
